import ConfigurationService from './apiclients/ConfigurationService';
// import * as zlib from 'zlib';

let createConfig = async () => {
    let hostname = window.location.hostname;

    let stackConfig;
    if (process.env.REACT_APP_IS_CONTAINER !== 'true' && (hostname === 'localhost' || hostname.indexOf('10.0.0.') !== -1)) {
        // stackConfig = {
        //     baseDomain: 'pirami.de',
        //     region: 'eu-west-1',
        //     userPoolId: 'eu-west-1_QPYwXZxmj',
        //     userPoolClientId: 'tntm5fqba7cq3p69cdbsi2iik',
        //     APIDomain: 'api-pirami.de',

        //     // Federated Login
        //     federatedUserPoolClientId: 'tntm5fqba7cq3p69cdbsi2iik',
        //     federatedDomainName: 'piramide.auth.eu-west-1.amazoncognito.com',
        //     federatedClaims: ['openid', 'email'],
        //     federatedConfig: 'SimsID',
        // };

        // http://localhost:3000/#error_description=attributes+required%3A+%5Bemail%5D&state=mQosl4NhXEFptfQolg0UEYCM1y8NsG8c&error=invalid_request

        // stackConfig = {
        //     baseDomain: 'dbschenkersolutionhub.com',
        //     region: 'eu-west-1',
        //     userPoolId: 'eu-west-1_7PFWh1g3D',
        //     userPoolClientId: 'tp2u02ger9cptgjv0gmgi6tnk',
        //     APIDomain: 'api-dbschenkersolutionhub.com',
        //     _stackTitle: 'solutionHUB',

        //     // Federated Login
        //     federatedUserPoolClientId: 'tp2u02ger9cptgjv0gmgi6tnk',
        //     federatedDomainName: 'dbschenkersolutionhub.auth.eu-west-1.amazoncognito.com',
        //     federatedClaims: ['openid', 'email'],
        //     federatedConfig: 'SimsID',
        // };

        stackConfig = {
            baseDomain: 'pdcvallcompanys.com',
            region: 'eu-west-1',
            userPoolId: 'eu-west-1_mTvG9Uoaw',
            userPoolClientId: '4dkldlh0np63854p9o9li8l48r',
            APIDomain: 'api-pdcvallcompanys.com',

            //Federated Login
            federatedUserPoolClientId: '4dkldlh0np63854p9o9li8l48r',
            federatedDomainName: 'vall.auth.eu-west-1.amazoncognito.com',
            federatedClaims: ['email', 'openid','groups','roles'],
            federatedConfig: 'AzApp-PDCGrupoVC',
        };

        // stackConfig = {
        //     baseDomain: 'meetpdc.com',
        //     region: 'eu-west-1',
        //     userPoolId: 'eu-west-1_qaLSPl4Hn',
        //     userPoolClientId: 'psttqn07c4jc9ca3p0j497iso',
        //     APIDomain: 'api-meetpdc.com',
        // };
    } else {
        try {
            stackConfig = await ConfigurationService.getStackConfiguration();
        } catch (err) {
            console.log('response err', err.message);
        }
    }

    // console.log('stackConfig', stackConfig);
    // aws cognito-idp describe-identity-provider --user-pool-id eu-west-1_QPYwXZxmj --provider-name SimsID
    let currStackData = stackConfig;
    let currAPIDomain = currStackData.APIDomain;
    let currStack = currStackData.baseDomain;

    let fileDelivery;
    if (process.env.REACT_APP_IS_CONTAINER === 'true') {
        // TABLET & SMARTPHONE
        fileDelivery = '/';
    } else {
        // WEB
        fileDelivery = `https://delivery.${currAPIDomain}/`;
    }

    let federatedLogin = {};
    if (currStackData.federatedUserPoolClientId !== undefined) {
        federatedLogin = {
            federatedUserPoolClientId: currStackData.federatedUserPoolClientId,
            federatedDomainName: currStackData.federatedDomainName,
            federatedClaims: currStackData.federatedClaims,
            federatedConfig: currStackData.federatedConfig,
            federatedCallbackUrl: window.location.origin,
            federatedGrantFlow: 'token', //'code', // "token"
        };
    }

    let result = {
        region: currStackData.region,
        cognito: {
            userPoolId: currStackData.userPoolId,
            appClientId: currStackData.userPoolClientId,

            // Federated Login
            ...federatedLogin,
        },
        ClientId: currStackData.userPoolClientId,

        PdcDomain: currStack,
        ApiDomain: currAPIDomain,
        AnalyticsService: `https://analytics.${currAPIDomain}/`,
        FileService: `https://file.${currAPIDomain}/`,
        TagService: `https://tag.${currAPIDomain}/`,
        ContentService: `https://content.${currAPIDomain}/`,
        FormService: `https://form.${currAPIDomain}/`,
        IdentityService: `https://identity.${currAPIDomain}/`,
        WebsocketService: `https://websocket.${currAPIDomain}/`,
        SearchService: `https://search.${currAPIDomain}/`,
        ShareService: `https://share.${currAPIDomain}/`,
        FileDelivery: fileDelivery,
        PlatformConfiguration: `https://static.${currAPIDomain}/`,
        /* FIXME: customization for kerry demo */
        ZohoService: `https://zoho.${currAPIDomain}/`,
        DeviceService: `https://device.${currAPIDomain}/`,
        PrintService: `https://print.${currAPIDomain}/`,
    };

    try {
        // localStorage
        const prefix = `CognitoIdentityServiceProvider.${result.cognito.appClientId}`;
        let exportable = {};
        for (let k in localStorage) {
            if (k.indexOf(prefix) !== -1) {
                exportable[k] = localStorage.getItem(k);
            }
        }
        // var exportableCompressed = encode(zlib.deflateSync(JSON.stringify(exportable)));

        // const exportableCompressed = JSON.stringify(zlib.deflateSync(JSON.stringify(exportable)));
        // console.log(exportable, result.cognito.appClientId);
    } catch (err) {
        console.log('Error config cognito', err);
    }
    console.log(result);
    return result;
};

export default createConfig;
